var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid current-campaign-div"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 campaign-text"
  }, [_c('h4', [_vm._v("Intensified Mission Indradhanush")]), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('p', [_vm._v("In 2014, The Ministry of Health And Family Welfare in India launched this program to fully immunize children of age up to two years and pregnant women with all available vaccines. To help promote and implement this extremely beneficial program,\n        Friends has been organising various vaccination camps in Roorkee.\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-md btn-warning",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events#cc'
      }
    }
  }, [_vm._v("See Our Gallery")])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h1', {
    staticClass: "campaign-heading"
  }, [_vm._v("Current Campaign")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 align-self-center"
  }, [_c('img', {
    staticClass: "img-fluid current-campaign-img",
    attrs: {
      "src": require("./Home-pics/mi-cover.jpg"),
      "alt": "Indra Dhanush"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e76ab8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/CurrentCampaign.vue
// module id = 9JlT
// module chunks = 0